import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ImageContainer = styled.div<{ height: number; markerX?: number; markerY?: number }>`
  width: 100%;
  max-height: ${({ height }) => height}px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  will-change: transform;

  img {
    width: 100% !important;
    object-fit: cover;
    object-position: ${({ markerX, markerY }) =>
      markerX !== undefined && markerY !== undefined ? `${markerX}% ${markerY}%` : 'center'};
  }

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    height: ${({ height }) => height / 2}px;
  }
`

export const LoaderContainer = styled.div<{ height: number }>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  height: ${({ height }) => height}px;

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    height: ${({ height }) => height / 2}px;
  }
`

export const FakeContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
`
